import template from './feesAndCharges.component.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    feesAndCharges: '<',
    products: '<',
    ticketOwner: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, $mdUtil, FeeAndCharge, FeeAndChargeType, helperService) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentCurrency = null;
      ctrl.organizationCountry = '';
      ctrl.organizationVat = 0;
      ctrl.availableFeeAndChargeTypes = [];
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.availableFeeAndChargeTypes = FeeAndChargeType.available;
        ctrl.feesAndCharges = ctrl.feesAndCharges || [];
        ctrl.products = ctrl.products || [];
        ctrl.ticketOwner = ctrl.ticketOwner || [];
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.preferredProduct = helperService.getPreferredProduct({ products: ctrl.products });
        ctrl.isReady = true;
      };

      ctrl.feeAndChargeAdd = ({ feeAndChargeType }) => {
        const feeAndCharge = FeeAndCharge.Blank(feeAndChargeType);
        if (feeAndChargeType?.id === ctrl.availableFeeAndChargeTypes[3]?.id) {
          if (
            ctrl.preferredProduct?.idLender &&
            ctrl.ticketOwner?.lenderAccreditations?.length
          ) {
            const lender = _.find(
              ctrl.ticketOwner.lenderAccreditations,
              (l) => l?.idLender === ctrl.preferredProduct.idLender
            );
            feeAndCharge.amount = _.multiply(
              ctrl.preferredProduct?.costs?.principal,
              lender && lender?.upfront
                ? _.divide(helperService.isNumber(lender?.upfront || 0, true), 100)
                : 0
            );
          }
        }
        ctrl.feesAndCharges.push(feeAndCharge);
        ctrl.saveFeesAndCharges();
      };

      ctrl.feeAndChargeDelete = ({ feeAndCharge }) => {
        helperService
          .deleteItem(
            ctrl.feesAndCharges,
            feeAndCharge,
            feeAndCharge?.name || feeAndCharge?.feeAndChargeType?.title,
            'fee and charge'
          )
          .then((result) => {
            if (result) {
              ctrl.saveFeesAndCharges();
            }
          });
      };

      ctrl.totalFeesAndCharges = () =>
        _.reduce(
          ctrl.feesAndCharges,
          (sum, n) => _.add(sum, helperService.isNumber(n?.amount, true)),
          0
        );

      ctrl.showError = () =>
        _.some(ctrl.feesAndCharges, (f) => !f?.name || !f?.amount || !f?.feePayable);

      ctrl.saveFeesAndCharges = _.debounce(
        () => ctrl.onFinished({ feesAndCharges: ctrl.feesAndCharges }),
        2500
      );

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
